module.exports = __webpack_public_path__ + "img/turfy2_fuji.fc892128.png";